export class Router {
  constructor(contentContainer) {
    this.routes = new Map();
    this.currentPage = null;
    this.currentRoute = null;
    this.contentContainer = contentContainer;
    this.routeChangeListeners = new Set();
    this.navigationToken = 0;
    this._onHashChange = this._onHashChange.bind(this);
    window.addEventListener('hashchange', this._onHashChange);
  }

  register(hash, loader) {
    this.routes.set(hash, { loader, module: null });
  }

  navigate(hash) {
    window.location.hash = hash;
  }

  async _onHashChange() {
    const token = ++this.navigationToken;
    const hash = window.location.hash.slice(1) || this.routes.keys().next().value;
    const route = this.routes.get(hash);
    if (!route) {
      const defaultRoute = this.routes.keys().next().value;
      if (defaultRoute) {
        window.location.hash = defaultRoute;
      }
      return;
    }

    if (this.currentPage) {
      this.currentPage.destroy();
      this.currentPage = null;
    }

    this.contentContainer.innerHTML = '';
    this.currentRoute = hash;
    this.contentContainer.innerHTML = '<div style="padding:24px;color:#9aa4b2;">Loading page...</div>';

    try {
      if (!route.module) {
        route.module = await route.loader();
      }

      // Ignore stale async loads when user navigates rapidly.
      if (token !== this.navigationToken) return;

      const page = route.module.createPage(this.contentContainer);
      page.init();
      this.currentPage = page;
    } catch (error) {
      console.error('Route load error:', error);
      this.contentContainer.innerHTML = `
        <div style="padding:24px;">
          <h2 style="margin:0 0 8px 0;">Failed to load page</h2>
          <p style="margin:0;color:#9aa4b2;">${error?.message || 'Unknown error'}</p>
        </div>
      `;
      return;
    }

    for (const cb of this.routeChangeListeners) {
      try { cb(hash); } catch (e) { console.error('Route change listener error:', e); }
    }
  }

  onRouteChange(callback) {
    this.routeChangeListeners.add(callback);
    return () => this.routeChangeListeners.delete(callback);
  }

  start() {
    if (!window.location.hash) {
      const defaultRoute = this.routes.keys().next().value;
      if (defaultRoute) {
        window.location.hash = defaultRoute;
        return;
      }
    }
    this._onHashChange();
  }

  destroy() {
    window.removeEventListener('hashchange', this._onHashChange);
    if (this.currentPage) {
      this.currentPage.destroy();
    }
  }
}
